const BitrixApi = require('./api');

module.exports = {
    /**
     * Регистрирование Bitrix service locator.
     * @param {ServiceLocator} locator Catberry's service locator.
     */
    register (locator) {
        locator.register('bitrix', BitrixApi, true);
    }
};



// WEBPACK FOOTER //
// ./services/bitrix/index.js